const AppSettings = {
  name: 'MOCK PORTAL',
  lang: 'pl',
  theme: 'themeSix',
  themeColors: [],
  orientation: '',
  mourning: false,
  facebook_api_key: 'TEST_FACEBOOK_API',
  banner_options: {
    rotation_banner_first: 5000,
    rotation_banner: 500
  },
  widgets: [
    {
      type: 'calendar',
      todayDate: '2021/5/4',
      slug: '/',
      data: [
        {
          date: `2021/5/7`,
          events: [
            {
              title: 'Nazwa wydarzenia',
              text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.',
              slug: '/'
            },
            {
              title: 'Nazwa wydarzenia',
              text:
                'Lorem ipsum dolor sit amet, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Viverra maecenas accumsan lacus vel facilisis.',
              slug: '/'
            }
          ]
        },
        {
          date: `2021/5/18`,
          events: [
            {
              title: 'Nazwa wydarzenia',
              text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, risus commodo viverra maecenas accumsan lacus vel facilisis.',
              slug: '/'
            },
            {
              title: 'Nazwa wydarzenia',
              text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.',
              slug: '/'
            }
          ]
        }
      ]
    },
    {
      type: 'box_spacer',
      height: 10
    },
    {
      type: 'list',
      title: 'NAJCZĘŚCIEJ CZYTANE',
      data: [
        {
          title:
            'Lorem amet, consecteur adipiscing elit, et dolore magna aliqua',
          slug: '/aktualnosci/przykladowy-news-1',
          image:
            'https://images.unsplash.com/photo-1452193550078-d7e45d3b834d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
        },
        {
          title:
            'Lorem ipsum adipiscing elit, et dolore magna aliqua Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod labore et dolore magna aliqua',
          slug: '/aktualnosci/przykladowy-news-2',
          image:
            'https://images.unsplash.com/photo-1556973662-49e68822ff5a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
        },
        {
          title:
            'Lorem  sit amet, consectetur adipiscing elit, sed do eiusmod labore et dolore magna aliqua',
          slug: '/aktualnosci/przykladowy-news-3',
          image:
            'https://images.unsplash.com/photo-1520777696580-6a7e966ed212?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
        },

        {
          title: 'Lorem ipsum dolor sit amet, consecteur',
          slug: '/aktualnosci/przykladowy-news-5',
          image:
            'https://images.unsplash.com/photo-1577281113585-457561adc190?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
        }
      ]
    },
    {
      type: 'box_spacer',
      height: 10
    },
    {
      type: 'fb_page_panel',
      href: 'https://www.facebook.com/orzysz',
      tabs: 'timeline,events,messages',
      hideCover: undefined,
      height: undefined,
      width: 500,
      showFacepile: false,
      hideCTA: undefined,
      smallHeader: true,
      adaptContainerWidth: true
    },
    {
      type: 'box_spacer',
      height: 10
    },
    {
      type: 'title',
      title: 'NAPISZ DO NAS'
    },
    {
      type: 'contact_form',
      text:
        'Jeśli masz interesujący temat, który możemy poruszyć lub byłeś(aś) świadkiem ważnego zdarzenia - napisz do nas.',
      placeholderEmail: 'e-mail',
      placeholderMessage: 'treść',
      agreementText:
        'Oświadczam, iż wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z ustawą z dnia 29.08.1997 r. o ochronie danych osobowych.'
    }
  ],
  menu: [
    {
      name: 'AKTUALNOŚCI',
      data: [
        {
          name: 'NAJNOWSZE INFORMACJE',
          data: [
            { name: 'GMINA', slug: '/strona' },
            { name: 'MIASTO', slug: '/podstrona' },
            {
              name: 'POWIAT',
              data: [{ name: 'WYDARZENIA', slug: '/link-3' }]
            }
          ]
        },
        {
          name: 'FESTYN',
          slug: '/information/przykladowy-artykul'
        },
        {
          name: 'ZBIÓRKI PUBLICZNE',
          data: [{ name: 'OSTATNIA ZBIÓRKA', slug: '/link-5' }]
        }
      ]
    },
    {
      name: 'SAMORZĄD',
      url_outside: 'https://www.google.pl',
      url_outside_blank: true,
      url_outside_nofollow: true
    },
    {
      name: 'DLA MIESZKAŃCA',
      url_outside: 'https://www.google.pl',
      url_outside_blank: false,
      url_outside_nofollow: false
    },
    { name: 'DLA TURYSTY', slug: '/link-9' },
    {
      name: 'DLA INWESTORA',
      data: [{ name: 'DZIAŁKI NA SPRZEDAŻ', slug: '/link-10' }]
    },
    { name: 'EDUKACJA', data: [{ name: 'SZKOŁY', slug: '/link-11' }] },
    { name: 'KULTURA', slug: '/link-12' },
    {
      name: 'SPORT',
      isMegamenu: true,
      data: [
        {
          title: 'ZAWODY SPORTOWE',
          data: [
            {
              title: 'BIEGI',
              slug: 'test',
              image:
                'https://images.unsplash.com/photo-1577281113585-457561adc190?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
            },
            {
              title: 'PING PONG',
              slug: '/aktualnosci/przykladowy-news-2',
              image:
                'https://images.unsplash.com/photo-1577281113585-457561adc190?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=50&h=50&q=50'
            }
          ]
        }
      ]
    },
    { name: 'KONTAKT', slug: '/link-14' }
  ],
  logo: 'https://i.imgur.com/i5YK10k.png',
  navMenuLeft: [
    {
      type: 'html',
      text:
        '<div class="logoTitle"><h1>URZĄD MIEJSKI <br/> W <strong>ORZYSZU</strong></h1></div>'
    }
  ],
  navMenu: [
    {
      type: 'nameday',
      date: '2021-5-6'
    },
    {
      type: 'vertical',
      width: 46
    },
    {
      type: 'weather',
      title: 'Pogoda',
      textColor: 'black',
      cityName: 'Olsztyn'
    },
    {
      type: 'vertical',
      width: 90
    },
    {
      type: 'html',
      text:
        '<a href="http://bip.orzysz.pl/"><img src="https://i.imgur.com/djiJ6rZ.png" /></a>'
    },
    {
      type: 'icon',
      slug: 'http://www.facebook.com',
      target: '_blank',
      rel: 'nofollow',
      icon: 'fab,facebook-f',
      size: '16px',
      color: 'black'
    },
    {
      type: 'icon',
      slug: 'http://www.youtube.com',
      target: '_blank',
      rel: 'nofollow',
      icon: 'fab,youtube',
      size: '16px',
      color: 'black'
    }
  ],
  cookies: {
    text:
      'Ta strona korzysta z plików cookie, kontynuując przeglądanie witryny, wyrażasz zgodę na korzystanie z plików cookie.',
    slug: '/polityka-ciastek'
  },
  footerMenu: [],
  copyright: {
    owner: 'Jan Kowalski',
    period: '2004-2020',
    producer: 'Mobischool',
    producerHref: 'https://wwww.google.pl'
  },
  footer: {
    0: [
      {
        type: 'image',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/c/c8/POL_Orzysz_COA.svg',
        title: 'Orzysz',
        slug: '#'
      }
    ],
    1: [
      {
        type: 'html',
        text:
          '<div class="logoTitle" ><h1> URZĄD MIEJSKI W <strong> ORZYSZU </strong> </h1><p> ul. Rynek 3 <br/> 12-250 Orzysz </p> </div> '
      }
    ],
    2: [
      {
        type: 'html',
        text:
          '<div class="menuFooterBox"> <ul> <li> <b> AKTUALNOŚCI </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> <ul> <li> <a href="#"> podstrona 1 </a> </li> <li> <a href="#"> podstrona 1 </a> </li> </ul> </li>  <li> <a href="#">podstrona 1 </a> </li> <li> <a href="#">podstrona 1 </a> </li> <li> <a href="#">podstrona 1 </a> </li> </ul> <ul> <li> <b> SAMORZĄD </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 </a> </li> </ul> <ul> <li> <b> DLA MIESZKAŃCA </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 </a> </li> </ul> <ul> <li> <b> DLA TURYSTY </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li> </ul> <ul> <li> <b> DLA INWESTORA </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li><li> <a href="#">podstrona 1 <a> </li><li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> <ul> <li> <a href="#"> podstrona 1 </a></li>  <li> <a href="#"> podstrona 1 </a></li> </ul>  </li>  <li> <a href="#">podstrona 1 <a> </li> </ul> <ul> <li> <b> EDUKACJA </b> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> <ul> <li> <a href="#"> podstrona 1 </a></li>  <li> <a href="#"> podstrona 1 </a></li> </ul>  </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li> </ul> <ul> <li> <b> KULTURA </b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li></ul>  <ul> <li> <b> SPORT</b> </li> <li> <a href="#">podstrona 1 <a> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  </ul>  <ul> <li> <b>KONTAKT</b> </li> <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> </li>  <li> <a href="#">podstrona 1 <a> <ul> <li> <a href="#"> podstrona 1 </a> </li> <li> <a href="#"> podstrona 1 </a> </li> </ul> </li>  <li> <a href="#">podstrona 1 </a> </li> <li> <a href="#">podstrona 1 </a> </li> <li> <a href="#">podstrona 1 </a> </li> </ul> </div>'
      }
    ],
    3: [
      {
        type: 'html',
        text:
          '<div class="officeHours"><b> GODZINY PRACY URZĘDU</b> <div class="workHours"> <p> poniedziałek </p> <p> 7.30 do 15:30 </p></div> <div class="workHours"> <p> wtorek </p> <p> 7.30 do 15:30 </p></div><div class="workHours"> <p> środa </p> <p> 7.30 do 15:30 </p></div><div class="workHours"> <p> czwartek </p> <p> 7.30 do 15:30 </p></div><div class="workHours"> <p> piątek </p> <p> 7.30 do 15:30 </p></div><p> <b> Burmistrz Orzysza przyjmuje interesantów </b></p> <p> w sprawach różnych w każdy wtorek </p><p> od godz. 10.00 do ostatniego interesanta </p></div>'
      }
    ]
  }
};

const WidgetsPopup = [
  {
    type: 'html',
    text:
      '<b>TO JEST WIDGET</> <br/> <br/><u>HTML</u><br/> <br/><u>HTML</u> <br/> <br/><u>HTML</u> <br/> <br/><u>HTML</u> <br/> <br/><u>HTML</u>'
  },
  {
    type: 'image',
    data: {
      title:
        'Lorem ipsum dolor sit amet, consecteur adipiscing elit, et dolore magna aliqua',
      slug: 'http://www.wikipedia.org/',
      image:
        'https://images.unsplash.com/photo-1452193550078-d7e45d3b834d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=450&h=450&q=50'
    }
  }
];

export { AppSettings, WidgetsPopup };

export default { AppSettings, WidgetsPopup };
